import React from 'react';
import AdminNavbar from '../AdminComponents/AdminNavbar/AdminNavbar';

const AdminLayout = () => {
  return (
    <div className="admin-main-wrapper">
      <AdminNavbar />
    </div>
  );
};

export default AdminLayout;